import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid2";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

import ApoderadosApi from "api/apoderadosApi";

const EditApoderado = ({ open, onClose, apoderado, onSuccess }) => {
  const [errors, setErrors] = useState({});
  const [apoderadoExistente, setApoderadoExistente] = useState(false);
  const [identificacionInicial] = useState(apoderado?.identificacion || "");
  const [formData, setFormData] = useState({
    tipo_identificacion: "",
    identificacion: "",
    nombre_completo: "",
    tarjeta_profesional: "",
    celular: "",
    email: "",
    direccion: "",
    ciudad: "",
    responsable: "",
    //estado: true,
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (apoderado) {
      setFormData((prev) => ({
        ...prev,
        tipo_identificacion: apoderado.tipo_identificacion || "",
        identificacion: apoderado.identificacion || "",
        nombre_completo: apoderado.nombre_completo || "",
        tarjeta_profesional: apoderado.tarjeta_profesional || "",
        celular: apoderado.celular || "",
        email: apoderado.email || "",
        direccion: apoderado.direccion || "",
        ciudad: apoderado.ciudad || "",
        responsable: apoderado.responsable || "",
      }));
    }
  }, [apoderado]);

  const handleIdentificacionBlur = async () => {
    const identificacion = formData.identificacion;
    if (identificacion.length < 5) {
      setErrors((prev) => ({
        ...prev,
        identificacion: "Debe tener al menos 5 caracteres",
      }));
      return;
    }
    try {
      //if (!apoderado) {}
      const response = await ApoderadosApi.fetchApoderadoByIdentificacion(identificacion);
      const acreedor = response.data;
      if (acreedor && !acreedor.error) {
        if (identificacionInicial == acreedor.identificacion) {
          setApoderadoExistente(false);
          setErrors((prev) => ({
            ...prev,
            identificacion: null,
          }));
        } else {
          setApoderadoExistente(true);
          setErrors((prev) => ({
            ...prev,
            //identificacion: "La identificación ya está registrada, se pasa a este nuevo apoderado.",
            identificacion: "La identificación ya está registrada.",
          }));
        }
        setFormData({
          ...acreedor,
          correos: acreedor.correos || [],
        });
      } else {
        setApoderadoExistente(false);
      }
    } catch (error) {
      console.error("Error al verificar apoderado:", error);
      setErrors((prev) => ({
        ...prev,
        identificacion: "Error al verificar la identificación",
      }));
    }
  };

  const handleIdentificacionChange = (e) => {
    const identificacion = e.target.value;
    const cleanValue = identificacion.replace(/\D/g, "").slice(0, 20);
    setFormData((prev) => ({ ...prev, identificacion: cleanValue }));
    setErrors((prev) => ({ ...prev, identificacion: "" }));
    setApoderadoExistente(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "nombre_completo") {
      // Permite letras, acentos, ñ/Ñ, espacios y números
      const cleanValue = value.replace(/[^a-záéíóúñüA-ZÁÉÍÓÚÑÜÜ0-9\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
    } else if (name === "celular") {
      const cleanValue = value.replace(/\D/g, "").slice(0, 15);
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
    } else if (name === "tipo_identificacion") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        identificacion: "",
      }));
      setErrors((prev) => ({ ...prev, identificacion: "" }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateEmailInput = (value) => {
    let cleanValue = value.trim();
    cleanValue = cleanValue.toLowerCase();
    cleanValue = cleanValue.replace(/[^a-z0-9@._-]/g, "");
    return {
      value: cleanValue,
      isValid: isValidEmail(cleanValue),
      errorMessage: isValidEmail(cleanValue) ? "" : "Por favor ingrese un Email válido",
    };
  };

  const handleEmailChange = (e) => {
    const result = validateEmailInput(e.target.value);
    const email = result.value;
    setFormData((prev) => ({ ...prev, email: email }));
    setErrors((prev) => ({ ...prev, email: result.errorMessage }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.identificacion) {
      setError("La Identificación es un campo obligatorio.");
      return;
    }
    try {
      const dataToSend = { ...formData };
      await ApoderadosApi.updateApoderado(apoderado.id, dataToSend);
      resetState();
      onSuccess();
    } catch (errors) {
      console.error("Error al guardar apoderado:", errors);
    }
  };

  const resetState = () => {
    setError(undefined);
    setErrors(undefined);
    setFormData({
      tipo_identificacion: "",
      identificacion: "",
      nombre_completo: "",
      tarjeta_profesional: "",
      celular: "",
      //email: "",
      direccion: "",
      ciudad: "",
      responsable: "",
      //estado: true,
    });
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="md" fullWidth>
      <DialogTitle>Editar Apoderado</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="errors" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo de Identificación
              </SuiTypography>
              <Select
                name="tipo_identificacion"
                value={formData.tipo_identificacion}
                onChange={handleChange}
              >
                <MenuItem value="CC">Cédula de Ciudadanía</MenuItem>
                <MenuItem value="NIT">Número de Identificación Tributaria</MenuItem>
                <MenuItem value="CE">Cédula de Extranjería</MenuItem>
                <MenuItem value="PAS">Pasaporte</MenuItem>
              </Select>
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Identificación
              </SuiTypography>
              <SuiInput
                name="identificacion"
                value={formData.identificacion}
                onChange={handleIdentificacionChange}
                onBlur={handleIdentificacionBlur}
                error={Boolean(errors?.identificacion)}
                fullWidth
                disabled={false}
              />
              {errors?.identificacion && (
                <SuiTypography variant="caption" color="error">
                  {errors?.identificacion}
                </SuiTypography>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiTypography variant="h6" fontWeight="light">
                Nombre Completo
              </SuiTypography>
              <SuiInput
                name="nombre_completo"
                value={formData.nombre_completo}
                onChange={handleChange}
                fullWidth
                disabled={apoderadoExistente}
              />
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Tarjeta Profesional
              </SuiTypography>
              <SuiInput
                name="tarjeta_profesional"
                value={formData.tarjeta_profesional || ""}
                onChange={handleChange}
                disabled={apoderadoExistente}
                fullWidth
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Correo Electrónico
              </SuiTypography>
              <SuiInput
                name="email"
                value={formData?.email || ""}
                onChange={handleEmailChange}
                type="email"
                disabled={apoderadoExistente}
              />
              {errors?.email && (
                <SuiTypography variant="caption" color="error">
                  {errors.email}
                </SuiTypography>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Dirección
              </SuiTypography>
              <SuiInput
                name="direccion"
                value={formData.direccion || ""}
                onChange={handleChange}
                multiline
                rows={2}
                fullWidth
                disabled={apoderadoExistente}
              />
            </Grid>
            <Grid size={3}>
              <SuiTypography variant="h6" fontWeight="light">
                Ciudad
              </SuiTypography>
              <SuiInput
                name="ciudad"
                placeholder="Ciudad"
                value={formData.ciudad || ""}
                onChange={handleChange}
                fullWidth
                disabled={apoderadoExistente}
              />
            </Grid>
            <Grid size={3}>
              <SuiTypography variant="h6" fontWeight="light">
                No. Celular
              </SuiTypography>
              <SuiInput
                name="celular"
                value={formData.celular || ""}
                onChange={handleChange}
                fullWidth
                disabled={apoderadoExistente}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            Actualizar
          </SuiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EditApoderado.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  apoderado: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default EditApoderado;
